import createFactory from './create-factory';

/**
 * expose class creation function
 */

export default createFactory(Object);
